
import { PlayIcon } from "@vue-hero-icons/outline";
export default {
  components: {
    PlayIcon,
  },

  methods: {
    openModal() {
      this.$vmodal.open({
        component: () => ({
          component: import("~/components/Modal/Introduction.vue"),
          delay: 200,
          timeout: 3000,
        }),
        wrapperProps: {
          clickCloseOutside: true,
          width: 750,
          height: 500,
          classes: "pre-default-modal",
        },
      });
    },
  },
};
